// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';

import { selectHasDomainCorporateProducts } from '@gandi/cart';

import {
  corporateResource,
  fetchOneCorpoPack,
  selectCorpoPack,
} from 'src/Cart/modules/corporate';
import { useAppSelector } from 'src/hooks/useAppSelector';
import { selectShopCurrent } from 'src/modules/organization/selectors';

export function useCorporateAlert(): {
  hasCorporateProduct: boolean,
  isCorporateOrg: boolean,
  date?: string,
  sharingId: string,
} {
  const dispatch = useDispatch();
  const currentOrg = useAppSelector(state => selectShopCurrent(state, true));
  const hasCorporateProduct = useAppSelector(selectHasDomainCorporateProducts);
  const sharingId = currentOrg?.id;

  const corpoPack = useAppSelector(state => selectCorpoPack(state, sharingId));
  const date = corpoPack?.[0]?.date_end;

  const corporate = currentOrg?.corporate && hasCorporateProduct;
  const shoulFetchCorpoPack = useAppSelector(state =>
    corporateResource.selectShouldFetchOne(state, sharingId),
  );
  const isCorporateOrg = currentOrg?.corporate;

  React.useEffect(() => {
    if (corporate && shoulFetchCorpoPack && currentOrg?.id) {
      dispatch(fetchOneCorpoPack(currentOrg.id));
    }
  }, [corporate, currentOrg?.id, dispatch, shoulFetchCorpoPack]);

  return { hasCorporateProduct, isCorporateOrg, date, sharingId };
}
